import { useMapOpenRequests } from '../useRequests/useRequests';
import { useQuestionnaireData } from '../useQuestionnaireData';
import { getQuestionnaireObject } from 'utils/questionnaire';
import { getMapAssignmentStatus } from 'pages/Home/components/features/Maps/utils';
import { useContext } from 'react';
import { UserContext } from 'context/UserContext';

export const useMapStatus = () => {
    const { user } = useContext(UserContext);
    const { requests, isLoading, error } = useMapOpenRequests();
    const { data, isLoading: isQuestionnaireDataLoading, error: questionnaireDataError } = useQuestionnaireData();
    const questionnaire = data && getQuestionnaireObject(data);

    return {
        ...getMapAssignmentStatus(user!, requests?.items, questionnaire),
        isLoading: isLoading || isQuestionnaireDataLoading,
        error: error || questionnaireDataError
    };
};
